export const RESET_STATE = 'RESET_STATE';
export const SET_CONSTANTS = 'SET_CONSTANTS';
